module.exports = __webpack_public_path__ + "static/img/welcome.9834989.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/welcome.png
// module id = CD6D
// module chunks = 16